import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { interval } from 'rxjs/observable/interval';
import { startWith, switchMap } from 'rxjs/operators';

/*
  Generated class for the WeatherProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class WeatherProvider {

  appId = '463d109920ae47fdeb181162a7230abe';

  constructor(public http: HttpClient) {
    console.log('Hello WeatherProvider Provider');
  }

  // Updates weather every 15 minutes
  weatherUpdate(city, country): Observable<WeatherData> {
    return interval(60000 * 15).pipe(startWith(0), switchMap(t => this.getWeather(city, country)));
  }

  getWeather(city, country): Observable<WeatherData> {
    return this.http.get<WeatherData>(
      `https://api.openweathermap.org/data/2.5/weather?q=${city},${country}&appid=${this.appId}&units=metric`
    )
  }


}


export interface Coord {
  lon: number;
  lat: number;
}

export interface Weather {
  id: number;
  main: string;
  description: string;
  icon: string;
}

export interface Main {
  temp: number;
  pressure: number;
  humidity: number;
  temp_min: number;
  temp_max: number;
}

export interface Wind {
  speed: number;
  deg: number;
  gust: number;
}

export interface Clouds {
  all: number;
}

export interface Sys {
  type: number;
  id: number;
  message: number;
  country: string;
  sunrise: number;
  sunset: number;
}

export interface WeatherData {
  coord: Coord;
  weather: Weather[];
  base: string;
  main: Main;
  visibility: number;
  wind: Wind;
  clouds: Clouds;
  dt: number;
  sys: Sys;
  id: number;
  name: string;
  cod: number;
}




// WEBPACK FOOTER //
// ./src/providers/weather/weather.ts